import DialogService from "primevue/dialogservice";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(DialogService);
});
